// This will allow messages to be recieved from a sourounding iframe
//
// Usage: {frame}.postMessage({targetUrl:url}, '*')
// e.g.
//   window.frames[0].postMessage({targetUrl:url}, '*')
//   cb.postMessage({targetUrl:url}, '*') (in the case of a named frame)
//

(function() {
    'use strict';

    angular
        .module('vhols')
        .factory('iFrameMessagingService', iFrameMessagingService);

    iFrameMessagingService.$inject = ['$window', '$rootScope', '$log'];

    function iFrameMessagingService($window, $rootScope, $log) {
        var service = {
            sendMessage : sendMessage
        };

        return service;

        function sendMessage(message){
            // Dispatch the event.
            // $log.debug(message.value.height);
            if($window.parent !== $window){
                $window.parent.postMessage(message, '*');
            }
        }

    }

})();
